import { useLayoutEffect, useState } from "react";

const THEME_STORAGE_KEY = "theme";

const getThemeValue = () => {
  if (typeof window === "undefined") {
    return false;
  }

  const savedTheme = window.localStorage.getItem(THEME_STORAGE_KEY);
  if (savedTheme) {
    return savedTheme === "dark";
  }

  return document.documentElement.getAttribute("data-theme") === "dark";
};

export const useBuyAdminTheme = () => {
  const [isDarkMode, setIsDarkMode] = useState(getThemeValue);

  useLayoutEffect(() => {
    window.localStorage.setItem(THEME_STORAGE_KEY, isDarkMode ? "dark" : "light");
    document.documentElement.setAttribute("data-theme", isDarkMode ? "dark" : "light");
  }, [isDarkMode]);

  return {
    isDarkMode,
    toggleTheme: () => setIsDarkMode((value) => !value),
  };
};
